import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Solution from '@/pages/Solution'
import MinimalistSolution from '@/pages/solution-content/MinimalistSolution'
import ProductCenter from '@/pages/ProductCenter'
import CompProduct from '@/pages/product-center-contet/CompProduct'
import SuccessCase from '@/pages/SuccessCase'
import SuccessDetails from '@/pages/success-case-content/SuccessDetails'
import CoreServices from '@/pages/CoreServices'
import ServiceDetails from '@/pages/cor-service-content/ServiceDetails'
import ProductDemo from '@/pages/ProductDemo'
import AboutMe from '@/pages/AboutMe'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/twoPage',
      name: 'Home',
      component: Home
    },
    {
      path: '/threePage',
      name: 'Home',
      component: Home
    },
    {
      path: '/fourPage',
      name: 'Home',
      component: Home
    },
    {
      path: '/fivePage',
      name: 'Home',
      component: Home
    },
    {
      path:"/solution",
      name:"Solution",
      component:Solution
    },
    {
      path:"/productCenter",
      name:"ProductCenter",
      component:ProductCenter
    },
    {
      path:"/CoreServices",
      name:"CoreServices",
      component:CoreServices
    },
    {
      path:"/successCase",
      name:"SuccessCase",
      component:SuccessCase
    },
    {
      path:"/aboutMe",
      name:"AboutMe",
      component:AboutMe
    },
    {
      path:"/minimalistSolution",
      name:"MinimalistSolution",
      component:MinimalistSolution
    },
    {
      path:"/compProduct",
      name:"CompProduct",
      component:CompProduct
    },
    {
      path:"/serviceDetails",
      name:"ServiceDetails",
      component:ServiceDetails
    },
    {
      path:"/successDetails",
      name:"SuccessDetails",
      component:SuccessDetails
    },
    {
      path:"/productDemo",
      name:"ProductDemo",
      component:ProductDemo
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   // 路由跳转后，让页面回到顶部
//   // chrome
//   document.body.scrollTop = 0; // firefox
//   document.documentElement.scrollTop = 0; // safari
//   window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
//   next();
//   //to 即将进入的路由
//   //from 即将离开的路由
//   //next 放行
// });



// WEBPACK FOOTER //
// ./src/router/index.js